import LinkInBio from "@/models/LinkInBio";

const state={
    linkInBio: new LinkInBio({id:""})
};

const getters={
    linkInBio: state => state.linkInBio,
    linkWithPappyonId: state => state.linkInBio.id,
};

const actions={
    setLinkInBio({commit}, linkInBio){
        commit("setLinkInBio", linkInBio);

    }
};

const mutations={
    setLinkInBio: (state, linkInBio) => {
        state.linkInBio = linkInBio;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
